const isGeneratedAccompanyingGuest = (guest) => (
  ['manager', 'rsvp'].includes(guest?.accompanying_guest_source)
  && Boolean(guest?.accompanying_owner_guest_id)
);

const toNonNegativeInteger = (value, fallback = 0) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : fallback;
};

export const normalizeGuestPartyResponse = (data = {}, fallbackPrimaryId = null) => {
  const group = (Array.isArray(data.group) ? data.group : [])
    .filter((guest) => !isGeneratedAccompanyingGuest(guest));
  const primaryGuestId = data.primary_guest_id || fallbackPrimaryId || null;
  const primary = group.find((guest) => guest.id === primaryGuestId) || null;
  const namedCompanionCount = primary ? Math.max(0, group.length - 1) : 0;
  const summaryTotal = Number(data.party_summary?.total_companion_count);
  const usesTotalCompanionContract = Number.isFinite(summaryTotal);
  const storedUnnamedCount = toNonNegativeInteger(primary?.accompanying_guests);
  const accompanyingCount = usesTotalCompanionContract
    ? Math.max(namedCompanionCount, summaryTotal)
    : namedCompanionCount + storedUnnamedCount;
  const apiMinimum = toNonNegativeInteger(data.minimum_accompanying_count);

  return {
    group,
    primaryGuestId,
    accompanyingCount,
    minimumAccompanyingCount: usesTotalCompanionContract
      ? Math.max(namedCompanionCount, apiMinimum)
      : namedCompanionCount,
    usesTotalCompanionContract,
  };
};

export const getInvitedItineraryEventIds = (data = {}, group = []) => {
  return Array.from(new Set(
    [
      ...(Array.isArray(data.invited_itinerary_event_ids) ? data.invited_itinerary_event_ids : []),
      ...group.flatMap((guest) => guest?.tagged_itinerary_event_ids || []),
    ].filter(Boolean)
  ));
};

export const serializeCompanionCount = (
  totalCompanionCount,
  namedGuestCount,
  usesTotalCompanionContract
) => {
  const total = toNonNegativeInteger(totalCompanionCount);
  if (usesTotalCompanionContract) return total;
  return Math.max(0, total - Math.max(0, namedGuestCount - 1));
};

export const formatCompanionSummary = (names = [], totalCompanionCount = 0) => {
  const namedCompanions = names
    .map((name) => String(name || '').trim())
    .filter(Boolean);
  const total = toNonNegativeInteger(totalCompanionCount);
  const unnamedCount = Math.max(0, total - namedCompanions.length);

  if (unnamedCount > 0) {
    const unnamedLabel = `${unnamedCount} more ${unnamedCount === 1 ? 'guest' : 'guests'}`;
    return namedCompanions.length > 0
      ? `${namedCompanions.join(', ')} and ${unnamedLabel}`
      : `${unnamedCount} ${unnamedCount === 1 ? 'guest' : 'guests'}`;
  }

  if (namedCompanions.length <= 1) return namedCompanions[0] || '';
  return `${namedCompanions.slice(0, -1).join(', ')} and ${namedCompanions.at(-1)}`;
};
